module.exports = __webpack_public_path__ + "static/media/ic_ellipse_selected.acb31dcb.svg";